import React from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';

const WelcomeBanner = ({ settings, stats }) => {
    const getGreeting = () => {
        const hour = new Date().getHours();
        if (hour < 12) return 'בוקר טוב';
        if (hour < 18) return 'צהריים טובים';
        return 'ערב טוב';
    };

    const getTeacherName = () => {
        if (settings?.teacher?.firstName && settings?.teacher?.lastName) {
            return `${settings.teacher.firstName} ${settings.teacher.lastName}`;
        }
        if (settings?.user?.firstName && settings?.user?.lastName) {
            return `${settings.user.firstName} ${settings.user.lastName}`;
        }
        return 'מורה';
    };

    const getTodayDate = () => {
        return new Date().toLocaleDateString('he-IL', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    return (
        <div className="card bg-gradient-primary text-white mb-20">
            <div className="card-body p-24">
                <div className="row align-items-center">
                    <div className="col-lg-8">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <div className="w-60-px h-60-px bg-white bg-opacity-20 rounded-circle d-flex align-items-center justify-content-center">
                                <Icon icon="mdi:account" className="text-2xl" />
                            </div>
                            <div>
                                <h4 className="mb-1 fw-bold">{getGreeting()}, {getTeacherName()}!</h4>
                                <p className="mb-0 opacity-75">{getTodayDate()}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 text-lg-end">
                        <div className="d-flex flex-column gap-2">
                            <Link to="/calendar" className="btn btn-primary btn-sm d-flex align-items-center gap-2 justify-content-center">
                                <Icon icon="mdi:calendar-plus" />
                                לוח שנה
                            </Link>
                            <Link to="/add-user" className="btn btn-light btn-sm d-flex align-items-center gap-2 justify-content-center">
                                <Icon icon="mdi:account-plus" />
                                הוסף תלמיד
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WelcomeBanner; 